// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "./assets/" + {"853":"revealer","915":"trending-now"}[chunkId] + ".css.liquid";
};